















import { Component, Prop, Vue } from 'vue-property-decorator';
import { KNOWLEDGE_CHECK_EVENTS as KCE} from '@/author/constants';

@Component
export default class KnowledgeCheck extends Vue {
  @Prop() layout !: string;
  @Prop() small !: boolean;
  @Prop({default:'#fff'}) backgroundColor !: string;
  parentEvents : string[] = [KCE.OPTION_MOUNTED, KCE.CLEAR_OPTIONS, KCE.OPTION_SELECTED, KCE.MOUNTED, KCE.SHOWING_FEEDBACK]

  // ParentProps
  accessibilityCorrectFeedback!: string;
  accessibilityIncorrectFeedback!: string;
  accessibilitySelectFeedback!: string;
  instantFeedback!:boolean;
  showFeedback!:boolean;

  created() {  
    this.setupParentProps();
    this.setupParentEvents(this.parentEvents);
  }
  setupParentEvents(events: string[]){
    events.map(event=>{
      this.$on(event, (option: any) => {
        this.$parent.$emit(event, {kc:true, ...option});
      });
      this.$parent.$on(event, (option: any) => {
        if (option.kc)
          return;
        this.$emit(event, {...option});
      });
    });
  }
  setupParentProps(){
    this.accessibilityCorrectFeedback = this.$parent.$props.accessibilityCorrectFeedback;
    this.accessibilityIncorrectFeedback = this.$parent.$props.accessibilityIncorrectFeedback;
    this.accessibilitySelectFeedback = this.$parent.$props.accessibilitySelectFeedback || this.$parent.$props.accessibilitySelectedFeedback;
    let parent: any = this.$parent;
    this.instantFeedback = parent.hasInstantFeedback;
    this.showFeedback = this.$parent.$props.showFeedback;
  }
}
